module.exports = __webpack_public_path__ + "img/noti1.fd31989e.jpeg";